"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountInfoPage = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var AccountInfoAction_1 = require("@/pages/accountInfo/actions/AccountInfoAction");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var MemberPage_1 = require("@/pages/common/components/MemberPage");
var AccountInfoEditForm_1 = require("@/pages/accountInfo/components/AccountInfoEditForm");
var AccountInfoReadForm_1 = require("@/pages/accountInfo/components/AccountInfoReadForm");
var mapStateToProps = function (state) { return state.accountInfo; };
var mapDispatchToProps = function (dispatch) { return ({
    onEditClick: function () { return dispatch(AccountInfoAction_1.default.onEditClick()); },
    onCancelClick: function () { return dispatch(AccountInfoAction_1.default.onCancelClick()); },
    onDeleteAccountClick: function () { return dispatch(AccountInfoAction_1.default.onDeleteAccountClick()); },
    onSalutationChanged: function (salutation) { return dispatch(AccountInfoAction_1.default.onSalutationChanged(salutation)); },
    onFirstNameChanged: function (firstname) { return dispatch(AccountInfoAction_1.default.onFirstNameChanged(firstname)); },
    onLastNameChanged: function (lastname) { return dispatch(AccountInfoAction_1.default.onLastNameChanged(lastname)); },
    onEmailChanged: function (email) { return dispatch(AccountInfoAction_1.default.onEmailChanged(email)); },
    onPhoneCodeChanged: function (code) { return dispatch(AccountInfoAction_1.default.onPhoneCodeChanged(code)); },
    onPhoneBodyChanged: function (body) { return dispatch(AccountInfoAction_1.default.onPhoneBodyChanged(body)); },
    onLanguageChanged: function (language) { return dispatch(AccountInfoAction_1.default.onLanguageChanged(language)); },
    onCurrencyChanged: function (currency) { return dispatch(AccountInfoAction_1.default.onCurrencyChanged(currency)); },
    onBirthdayDayChanged: function (day) { return dispatch(AccountInfoAction_1.default.onBirthdayDayChanged(day)); },
    onBirthdayMonthChanged: function (month) { return dispatch(AccountInfoAction_1.default.onBirthdayMonthChanged(month)); },
    onBirthdayYearChanged: function (year) { return dispatch(AccountInfoAction_1.default.onBirthdayYearChanged(year)); },
    onUpdateClicked: function () { return dispatch(AccountInfoAction_1.default.onUpdateClicked()); },
}); };
exports.accountInfoPage = function (props) {
    var renderAccountInfo = function (props) {
        return (React.createElement("div", { id: "accountinfo-page", className: "l-container__main", style: { maxWidth: '100%' } },
            React.createElement("div", { style: { maxWidth: '1000px' } },
                React.createElement("div", { className: "l-pad-content" },
                    React.createElement("div", { className: "c-page-header c-page-header--center-mobile" },
                        React.createElement("div", { className: "c-page-header__body" },
                            React.createElement("div", { className: "c-page-header__title" }, props.nameTitle),
                            React.createElement("div", { className: "c-page-header__caption" }, props.nameCaption))),
                    props.isEditing ? React.createElement(AccountInfoEditForm_1.AccountInfoEditForm, __assign({}, props)) : React.createElement(AccountInfoReadForm_1.AccountInfoReadForm, __assign({}, props)))),
            React.createElement(Megafoot_1.default, null)));
    };
    return (React.createElement(MemberPage_1.default, null, renderAccountInfo(props)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.accountInfoPage);
